import { FLEET_ASSET_DOCUMENT_STATUS_LABEL } from '../../../constants/fleetAssets';
import { useStyles } from '../../../hooks/useStyles';
import {
  FleetAssetDocumentData,
  FleetAssetDocumentList,
  FleetAssetDocumentStatus,
  FleetAssetDocumentType,
} from '../../../types/fleet';

export function useFleetAssetDocuments(documents?: FleetAssetDocumentList) {
  const { theme } = useStyles();
  const insurancePolicy = documents?.[FleetAssetDocumentType.insurancePolicy];
  const vehicleRegistration = documents?.[FleetAssetDocumentType.vehicleRegistration];
  const emissionsTest = documents?.[FleetAssetDocumentType.emissionsTest];

  const getDocumentColor = (document?: FleetAssetDocumentData) => {
    if (document?.status === FleetAssetDocumentStatus.valid) return theme.colors.contentPositive;
    if (document?.status === FleetAssetDocumentStatus.expired) return theme.colors.contentNegative;
    if (document?.status === FleetAssetDocumentStatus.about_to_expire) return theme.colors.contentWarning;
    return theme.colors.contentTertiary;
  };

  const getDocumentStatus = (status?: FleetAssetDocumentStatus) => {
    if (status) {
      return FLEET_ASSET_DOCUMENT_STATUS_LABEL[status] || '-';
    }
    return '-';
  };

  return {
    getDocumentStatus,
    getDocumentColor,
    insurancePolicy: {
      status: getDocumentStatus(insurancePolicy?.status),
      color: getDocumentColor(insurancePolicy),
      document: insurancePolicy,
    },
    vehicleRegistration: {
      status: getDocumentStatus(vehicleRegistration?.status),
      color: getDocumentColor(vehicleRegistration),
      document: vehicleRegistration,
    },
    emissionsTest: {
      status: getDocumentStatus(emissionsTest?.status),
      color: getDocumentColor(emissionsTest),
      document: emissionsTest,
    },
  };
}
